export var convertStringToPascalCase = function (value) {
    if (!value)
        return "";
    return value
        .split(" ")
        .map(function (word) { return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase(); })
        .join(" ");
};
